module.exports = __webpack_public_path__ + "static/media/Boochukil Translated by J_Lee_77777.c57075b6.md";